import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from "@angular/core";
import { AdvAnnouncementWithExt } from "@onsip/web/features/administrators/announcements/announcementsPage/adv-announcements-page.component";
import { E2eLocators } from "@onsip/e2e/configs/locators";

@Component({
  selector: "onsip-adv-announcements-basic-view",
  templateUrl: "./adv-announcements-basic-view.component.html",
  styleUrls: ["./adv-announcements-basic-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdvAnnouncementsBasicViewComponent {
  _dontUse = true;
  @Input() announcement!: AdvAnnouncementWithExt;
  @Input() transferToText!: string | undefined;
  @Output() editPanel = new EventEmitter<void>();
  E2eLocators = E2eLocators;

  constructor() {}

  togglePanel(): void {
    this.editPanel.emit();
  }
}
